<template>
  <img class="key" src="./img/key/key-transparent.preload.png" />
  <!-- <div class="key-con">
  </div> -->
  <!-- <div class="key-image"> -->
    <!-- <img src="./img/key/key-transparent.png" class="key" /> -->
    <!-- <img src="./img/sparks/spark-0.png" class="spark-0" />
    <img src="./img/sparks/spark-0.png" class="spark-1" /> -->
  <!-- </div> -->
</template>

<script>
export default {
}
</script>

<style scoped>
/* @keyframes flash {
  0% {
    opacity: 0;
    transform: rotate(0deg) scale(1.0);
  }
  50% {
    opacity: 1;
    transform: rotate(360deg) scale(1.0);
  }
  100% {
    opacity: 0;
    transform: rotate(720deg) scale(1.0);
  }
} */

@keyframes fadeIn {
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}


/* .key-con{
  width: 100%;
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
} */
.key{
  position: absolute;
  top: 95px;
  left: calc(50% - 90px / 2);
  width: 90px;
  animation: fadeIn 0.167s;
}
</style>



// WEBPACK FOOTER //
// src/components/Parts/KeyImage/KeyImage.vue